import { createAction } from '@reduxjs/toolkit';

import types from './types';

const searchByFileName = createAction<string>(types.SEARCH_FILES_BY_NAME);

export default {
  searchByFileName,
};
